import apiClient from '../client';
import ENDPOINTS from '../endpoints';

const imagesService = {
  /* Unsplash photo suggestions (proxied by the backend). Normalizes the response
     to a plain list of image URLs regardless of wrapper/Unsplash shape. */
  searchUnsplash: async (q, count = 8) => {
    const res = await apiClient.get(ENDPOINTS.ROOM_PARENT_ADMIN.UNSPLASH_PHOTOS, { params: { q, count } });
    const list =
      res?.data?.photos ||
      res?.data?.results ||
      (Array.isArray(res?.data) ? res.data : null) ||
      res?.photos ||
      res?.results ||
      (Array.isArray(res) ? res : []);
    return list
      .map((p) =>
        typeof p === 'string'
          ? p
          : p?.urls?.small || p?.urls?.thumb || p?.urls?.regular || p?.url || p?.src || null
      )
      .filter(Boolean);
  },
};

export default imagesService;
